import { ReactElement } from 'react';
import { Input } from '~/components';
import { SetpointSelection } from '../types';

interface RemoteControlSetpointFieldsProps {
  selection: SetpointSelection;
  onChange: (selection: SetpointSelection) => void;
  t: (key: string) => string;
}

export function RemoteControlSetpointFields({
  selection, onChange, t,
}: Readonly<RemoteControlSetpointFieldsProps>): ReactElement {
  return (
    <div style={{
      display: 'flex', flexDirection: 'row', gap: 10, width: '100%',
    }}
    >
      <Input
        placeholder={t('digite')}
        label={t('minimo')}
        value={selection.minimum ?? ''}
        suffix="°C"
        onChange={(event) => onChange({ ...selection, minimum: event.target.value.replace(',', '.') })}
        data-test-id="batchRemoteControlMinimumSetpoint"
      />
      <Input
        placeholder={t('digite')}
        label={t('maximo')}
        value={selection.maximum ?? ''}
        suffix="°C"
        onChange={(event) => onChange({ ...selection, maximum: event.target.value.replace(',', '.') })}
        data-test-id="batchRemoteControlMaximumSetpoint"
      />
    </div>
  );
}
